
 <div class="w-full md:px-[3.5rem]">    

    <div class="container mx-auto  mt-16 mb-20 ">

        <div class="flex flex-col w-full gap-4">
            <div *ngFor="let item of items"
                class="w-full bg-white rounded-lg overflow-hidden border-b border-gray-300 flex items-center p-4 justify-between">

                <div class="w-28 h-24">
                    <img [src]="absoluteMediaUriService.getAbsoluteMediaUri(item?.imageUrl)" [alt]="item.name"
                        class="w-full h-full object-cover rounded-lg">
                </div>

                <div class="flex flex-col pl-4  flex-1">

                    <p class=" text-[var(--charcoal)] mt-2 md:mt-0 m-0"> {{item.biddingType}} </p>

                    <div class="flex items-center">
                        <h3 class="text-xl font-semibold text-[var(--dark-teal)] font-noto-serif cursor cursor-pointer hover:underline"
                            [routerLink]="['/item-detals-bc', 'item', item.id]" [innerHTML]="item.name | sanitizeHtmlText">
                        </h3>

                        <fa-icon [icon]=" item?.isFavorite ? faBookmarkSolid : faBookmarkRegular"
                            (click)="toggleFavorite(item.id, item.isFavorite)" class="ml-4 text-2xl text-blue-300 cursor-pointer
            transition hover:scale-105 hover:bg-white"></fa-icon>
                    </div>


                    <h3 class=" cursor-pointer m-0 hover:underline text-custom-gray-dark   mt-3 break-words whitespace-normal max-w-[85%] line-clamp-2"
                        [routerLink]="['/auction',  item.auctionId]" [innerHTML]="item.orgName | sanitizeHtmlText">
                    </h3>
                </div>

                <div class="flex-1 flex flex-col justify-center text-center  ">

                    @if (item.currentLeadingBid || item.buyNowPrice) {
                    <p class="mt-1">
                        <span class="text-lg font-semibold text-custom-black">
                            {{ (item?.currentLeadingBid ?? item?.buyNowPrice) | currency:'USD':'symbol':'1.2-2'}}
                        </span>
                        <span class="text-[var(--sky-blue)]  font-semibold ml-2">
                            {{ item.currentLeadingBid ? (item.numberOfBids === 0 ? 'Opening Bid' : 'Leading Bid') : 'Buy Now' }}
                        </span>
                    </p>
                    }
                    <p>
                        <span *ngIf="item.estimatedValue; else noEstimatedValue" class="text-[#6E6E6E] text-sm">
                            {{ isAmountEstimatedValue(item.estimatedValue.toString()) ? (item.estimatedValue | currency ) +
                            ' Estimated Value':
                            'Priceless' }}
                        </span>
                        <ng-template #noEstimatedValue>
                            <span class="text-gray-500 text-xs invisible">-ddd</span>
                        </ng-template>
                    </p>
                </div>
                <div class="flex flex-col flex-1 items-center w-80">
                        <button pButton [routerLink]="['/item-detals-bc', 'item', item.id]"
                            class="mt-6 lg:mt-2 lg:h-[35px]  w-full  rounded-md flex items-center justify-center ">
                            <span class=" text-white text-center w-ful font-noto-serif">
                                @if (item.currentLeadingBid > 0) {
                                <span>Place a Bid</span>
                                } @else if (item.buyNowPrice) {
                                <span>Buy Now</span>
                                } @else {
                                <span>See More</span>
                                }
                            </span>
                        </button>
                    <div class="text-center mt-2 ">
                        <p class="h-5 text-[var(--fs-dark)] font-medium italic text-sm">
                            {{ timeLeftService.getTimeLeft(item.openingDate, item.closingDate) }}s
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
 </div>